import React from "react"
//import I18n from "i18n-js/index.js.erb"
import Switch from "../Switch/Switch"

class UnsettledFolioDialog extends React.Component {
  constructor(props) {
    super(props)
  };

  render() {
    return(
      <div>
        {this.renderWarningMessage()}
        {this.renderNewFolioOption()}
      </div>
    );
  };

  renderWarningMessage() {
    return(
      <div className="alert alert-warning">
        <h5 style={{ textAlign: 'center' }}><strong>{I18n.t('rooms_must_have_at_least_one_open_folio')}</strong></h5>
      </div>
    );
  };

  renderNewFolioOption() {
    return(
      <div className="row" >
        <div className="col-sm-12">
          <div className="panel panel-default">
            <div className="panel-body">
              <h3 className="panel-heading-text" style={{ borderBottom: '1px solid #DFDFDF', paddingBottom: 20, marginTop: 5, marginBottom: 10 }}>{I18n.t('new_folio')}</h3>
              <div>
                <label style={{marginBottom: '15px'}}>{I18n.t('open_new_folio')}</label>
                <Switch defaultValue={this.props.openNewFolio} onChange={this.props.onChangeOpenNewFolio} />
              </div>
              {this.props.openNewFolio ? this.renderFolioName() : null}
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderFolioName() {
    return(
      <div style={{marginTop: '12px'}}>
        <div className="row">
          <div className="col-sm-4">
            <label style={{ marginBottom: '12px' }}>{I18n.t('name')}</label>
            <input name="name" value={this.props.newFolioNameDialog ? this.props.newFolioNameDialog : ""} onChange={this.props.onChangeNewFolioNameDialog} className="form-control" />
          </div>
        </div>
      </div>
    );
  };
};

export default UnsettledFolioDialog